import {v4 as uuidv4} from 'uuid'


export const codeExtractor = (data: {code: string}) => data.code

export const generatedCode = () => uuidv4();




